import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoginComponent } from './components/login/login.component';
import { RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ToastModule } from 'primeng/toast';
import { MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { InputTextModule } from 'primeng/inputtext';
import { PasswordModule } from 'primeng/password';
import { DropdownModule } from 'primeng/dropdown';
import { CheckboxModule } from 'primeng/checkbox';
import { SelectButtonModule } from 'primeng/selectbutton';
import { TooltipModule } from 'primeng/tooltip';
import { ForgotPasswordComponent } from './components/forgot-password/forgot-password.component';
import { RegisterComponent } from './components/register/register.component';
import { TranslocoModule } from '@jsverse/transloco';
import { AuthService } from './services/auth-service/auth.service';
import { TokenService } from './services/auth-service/token.service';
import { authInterceptor } from '../interceptors/auth.interceptor';
import { credentialsInterceptor } from '../interceptors/credentials.interceptor';
import { companyContextInterceptor } from '../interceptors/company-context.interceptor';
import { RegistrationService } from './services/registration.service';
import { PasswordStrengthIndicatorComponent } from '../shared/components/password-strength-indicator/password-strength-indicator.component';
import { RegisterCreateComponent } from './components/register/register-create/register-create.component';
import { RegisterJoinComponent } from './components/register/register-join/register-join.component';
import { AuthHeaderComponent } from './components/shared/auth-header/auth-header.component';
import { LanguageSelectorComponent } from '../shared/components/language-selector/language-selector.component';

@NgModule({
  declarations: [LoginComponent, RegisterComponent, ForgotPasswordComponent],
  imports: [
    CommonModule,
    RouterLink,
    RouterOutlet,
    RouterLinkActive,
    FormsModule,
    ReactiveFormsModule,
    ToastModule,
    ButtonModule,
    IconFieldModule,
    InputIconModule,
    InputTextModule,
    PasswordModule,
    DropdownModule,
    CheckboxModule,
    SelectButtonModule,
    TooltipModule,
    TranslocoModule,
    PasswordStrengthIndicatorComponent,
    RegisterCreateComponent,
    RegisterJoinComponent,
    AuthHeaderComponent,
    LanguageSelectorComponent,
  ],
  providers: [
    MessageService,
    AuthService,
    TokenService,
    RegistrationService,
    authInterceptor,
    credentialsInterceptor,
    companyContextInterceptor,
  ],
})
export class AuthModule {}
